// extracted by mini-css-extract-plugin
export var noSpinners = "_s8-6";
export var percentageInput = "_s8-7";
export var variantColor1 = "_s8-0";
export var variantColor2 = "_s8-1";
export var variantColor3 = "_s8-2";
export var variantColor4 = "_s8-3";
export var variantColor5 = "_s8-4";
export var variantColor6 = "_s8-5";